/* eslint-disable no-unused-vars, no-return-assign */
/* Commerce Utilities for connecting to Magento GraphQL & Rest Services */

const CommerceKR = (() => {
	let baseURL = 'https://uat-shopkr.batj.jp/shop/graphql';

	if (typeof graphql !== 'undefined') {
		baseURL = graphql;
	}

	const cartUpdate = $.Event('cart-update');
	const cartAction = $.Event('cart-action');
	const cartError = $.Event('cart-error');

	let lastItemAdded = '';
	let lastActionTaken = '';

	// TODO: Remove fixed page names from array and add logic to check ungated pages
	const ungatedPagesArr = ['login', 'home', 'account-registration', 'forgot-password', 'gated', 'reset-password', 'devices'];

	const credentials = {
		INCLUDE: 'include',
		SAMEORIGIN: 'same-origin',
	};

	const userStatus = {
		AUTH: 'authenticated',
		RESETCART: 'resetcartvalues',
		UNAUTH: 'unauthorized',
		NOREDIRECT: 'noredirect'
	};

	const appCartInitSource = {
		DEFAULT: 'default',
		CART: 'cart',
		PLPPDP: 'plppdp',
		AUTH: 'authenticated'
	};

	// private method(s)
	const _constructor = () => {
		console.log(' --- First call in Commerce ---');
		_setCookieVal('commerce-country-value', document.body.dataset.country);
		if (document.body.dataset.country == 'kr') {
			_toggleKakoLiveChat();
			_redirectNormalUser();
		}
		/* eslint-disable-next-line no-use-before-define */
		_cartCookieCheck();
	};

	/**
	 * Method to handle kakao live chat with authentication
	 * Counter set to call the function 10 times before stopping
	 */
	const _toggleKakoLiveChat = () => {
		let intervalFn = null;
		let chkCounter = 0;
		let kakaoliveChatLoaded = false;

		let checkAndSetKakaoChat = function () {
			if (chkCounter <= 10) {
				if (CommerceKR != undefined && document.getElementById('HappytalkIframe') != null) {
					chkCounter++;
					kakaoliveChatLoaded = true;

					const authCheck = CommerceKR.isLoggedInUser();
					if (authCheck) {
						document.getElementById('HappytalkIframe').style.display = 'block';
						clearInterval(intervalFn);
					} else {
						document.getElementById('HappytalkIframe').style.display = 'none';
					}
				} else {
					kakaoliveChatLoaded = false;
				}
			} else {
				clearInterval(intervalFn);
			}
		};

		intervalFn = setInterval(checkAndSetKakaoChat, 1000);

	}

	// Check for cart cookie
	const _cartCookieCheck = () => {
		const cartCookie = document.cookie.match(
			`(^|;) ?commerce-cart-id=([^;]*)(;|$)`
		);
		const cartData = localStorage.getItem('commerce-cart-storage');

		// Clear local cart storage if no cart cookie is found.
		if (!cartCookie && cartData) {
			localStorage.removeItem('commerce-cart-storage');
		}
	};

	// Fetch GET Request
	const _makeGetRequest = async (query, variables, creds) => {
		// Clean strings of new lines and unnecessary space
		const queryString = query.replace(/\s\s+/g, ' ');
		const variablesString = variables ?
			variables.replace(/\s\s+/g, ' ') :
			'';

		const queryEncodeString = `?query=${encodeURIComponent(queryString)}`;
		const variablesEncodeString = `&variables=${encodeURIComponent(
			variablesString
		)}`;
		const url =
			baseURL +
			queryEncodeString +
			(variables ? variablesEncodeString : '');

		// let authcookie = await Utils.getCookie('commerce-auth-token');
		const request = await fetch(url, {
			method: 'GET',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				store
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						return false;
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};

	const _makeGetRequestRest = async (url) => {
		try {
			let authcookie = await Utils.getCookie('commerce-auth-token');

			var myHeaders = new Headers();
			myHeaders.append("Authorization", "Bearer " + authcookie);
			myHeaders.append("Content-Type", "application/json");

			var options = {
				method: 'GET',
				headers: myHeaders,
			};

			const request = fetch(url, options)
				.then(response => response.json())
				.then((response) => {
					// Console error messages and return
					if (response.errors && response.errors.length) {
						response.errors.map((error) => {
							/* eslint-disable-next-line no-console */
							console.log('Response failed: ', error.message);
							return false;
						});
					}

					return response;
				})
			return request;
		} catch (error) {
			console.log("Error :", error)
		}
	};

	const _makeGetRequestWithAuthentication = async (query, variables, creds) => {
		// Clean strings of new lines and unnecessary space
		const queryString = query.replace(/\s\s+/g, ' ');
		const variablesString = variables ?
			variables.replace(/\s\s+/g, ' ') :
			'';

		const queryEncodeString = `?query=${encodeURIComponent(queryString)}`;
		const variablesEncodeString = `&variables=${encodeURIComponent(
			variablesString
		)}`;
		const url =
			baseURL +
			queryEncodeString +
			(variables ? variablesEncodeString : '');

		let authcookie = CommerceKR.getCookieVal('commerce-auth-token');

		const request = await fetch(url, {
			method: 'GET',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authcookie}`,
				store
			},
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						CommerceKR.handleAuthToken(error);
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};

	// Fetch POST Request
	const _makePostRequest = async (query, creds) => {
		const request = await fetch(baseURL, {
			method: 'POST',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				store
			},
			body: query,
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						return false;
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};
	const _makePostRequestRest = async (url, body) => {
		try {
			let authcookie = CommerceKR.getCookieVal('commerce-auth-token');
			const request = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authcookie}`,
				},
				body: JSON.stringify(body),
			})
				.then((response) => response.json())
				.then((response) => {
					if (response.errors && response.errors.length) {
						response.errors.map((error) => {
							/* eslint-disable-next-line no-console */
							console.log('Response failed: ', error.message);
							CommerceKR.handleAuthToken(error);
						});
					}

					return response;
				})
				.catch((error) => {
					console.log('Request failed: ', error);
				});

			return request;
		} catch (error) {
			console.log("Error: ", error)
		}
	};

	const _makePostRequestWithAuthentication = async (query, creds) => {

		let authcookie = CommerceKR.getCookieVal('commerce-auth-token');

		const request = await fetch(baseURL, {
			method: 'POST',
			credentials: creds || credentials.SAMEORIGIN,
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authcookie}`,
				store
			},
			body: query,
		})
			.then((response) => response.json())
			.then((response) => {
				// Console error messages and return
				if (response.errors && response.errors.length) {
					response.errors.map((error) => {
						/* eslint-disable-next-line no-console */
						console.log('Response failed: ', error.message);
						CommerceKR.handleAuthToken(error);
					});
				}

				return response;
			})
			.catch((error) => {
				/* eslint-disable-next-line no-console */
				console.log('Request failed: ', error);
			});

		return request;
	};

	/**
	 * Logic to handle token regeneration & application reload
	 * @params  errorObj - Response error containing message and extention category
	 */
	const _handleAuthToken = async (errorObj) => {
		if (errorObj.extensions.category == "graphql-authorization") {
			const refToken = CommerceKR.getCookieVal('commerce-auth-refresh-token');
			const tokenIssueState = await CommerceKR.regenerateToken(refToken);
			if (!tokenIssueState) {
				CommerceKR.checkPageRedirect(true, 'login', '', '', false, '', true);
			} else {
				window.location.replace(window.location.href);
				return tokenIssueState;
			}
		}
	}

	const _redirectNormalUser = () => {
		console.log('_redirectNormalUser');
		const key = new URLSearchParams(window.location.search).get('verify_key')
		const customerId = new URLSearchParams(window.location.search).get('customer_id')
		const isAuthorMode = _isAuthorMode();
		// redirect All pages
		/*
		if(!_isLoggedInUser() && window.location.href.indexOf("o2onewcoupon") != -1) {
			localStorage.setItem("setUrl", window.location.href);
		}
		*/
		if (isAuthorMode)
			return
		if (window.location.href.indexOf("gated") > -1 || document.getElementsByTagName('meta').genericUserAccess)
			return
		if (window.location.href.indexOf("home") > -1 && key && customerId)
			return
		if (!(_isGuestUser() || _isLoggedInUser())) {
			// Commerce.redirectToGatedPage()
			// Save current URL while redirecting to /gated
			console.log('set pages');
			localStorage.setItem("setUrl", window.location.href);
			const country = document.body.dataset.country;
			const language = document.body.dataset.language;
			window.location.href = `${window.location.protocol}//${window.location.host}/${country}/${language}/gated`
		}
	}

	const _getQueryParameters = (_s) => {
		const locationSearch = window.location.search ?
			window.location.search :
			'';
		const query = _s || locationSearch;
		if (!query) return false;
		const parameters = query.replace('?', '').split('&');
		const result = {};
		if (!parameters.length) return false;
		for (let i = 0; i < parameters.length; i++) {
			const iteredParam = parameters[i];
			const item = iteredParam.split('=');
			result[item[0]] = decodeURIComponent(item[1]);
		}
		return result;
	};


	const _checkDanalVerification = () => {
		console.log('check danal_verified')
		let queryParameters = _getQueryParameters();
		// disposable login - redirect should work all pages not only home 
		if (queryParameters.danal_verified == "true") {
			localStorage.setItem('danal_verified', 'true');
		}
		if (localStorage.getItem('danal_verified'))
			return true;
		return false;
	}

	const _isGuestUser = () => {
		let authcookie = _getCookieVal('commerce-auth-token');
		let guestUserDanal = _checkDanalVerification();
		let transactionId = localStorage.getItem("transaction_id");

		if (transactionId && guestUserDanal && !authcookie) {
			localStorage.setItem('is_guest_user', 'true');
			return true
		}

		return false
		// return true
	}

	const _showLoginModal = () => {
		const modal = $(".login-popup-section #cancel-order")
		modal?.show()
	}

	const _hideLoginModal = () => {
		const modal = $(".login-popup-section #cancel-order")
		modal?.hide()
	}

	const _handleLoginPageRedirection = () => {
		const discardButton = document.querySelector(".login-popup-section .cancel-order-cta")
		const loginRedirectButton = document.querySelector(".login-popup-section .no-cancel-cta")
		discardButton?.addEventListener('click', Commerce.hideLoginModal)
		loginRedirectButton?.addEventListener('click', function () {
			Utils.setLocalStorage("login-back-url", window.location.href);
			_checkPageRedirect(true, 'login', '', '', '', '', true);
		})

	}

	/**
	 * Get cookie value
	 * @params  cname - cookie to search
	 */
	const _getCookieVal = (cname) => {

		if (Utils != undefined) {
			return Utils.getCookie(cname);
		} else {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return null;
		}
	};

	/**
	 * Delete cookie
	 * @params  name - cookie to search
	 */
	const _deleteCookie = (name) => {
		document.cookie = name + '=; samesite=strict; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
	};

	/**
	 * Set cookie
	 * @params  key - cookie key
	 * 			value - cookie value
	 * 			expiry - expiry time for a cookie in minutes
	 * 			sameSite - samesite cors value : strict default
	 */
	const _setCookieVal = (key, value, expiry = 1, sameSite = "strict") => {
		const expires = new Date();
		const isSecure = window.location.protocol === 'https:';
		expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);

		if (Utils != undefined) {
			Utils.setCookie('commerce-cart-id', value, 1, 'Lax');
		} else {
			document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(
				value
			)};${isSecure ? 'secure;' : ''
				}samesite=${sameSite};expires=${expires.toUTCString()};path=/`;
		}
	};

	/**
	* Set localstorage item
	* @params   key - localstorage key
	* 			value - cookie value
	*/
	const _setLocalStorageItem = (key, value) => {
		if (Utils != undefined) {
			Utils.setLocalStorage(key, value);
		} else {
			localStorage.setItem(key, JSON.stringify(value));
		}
	};

	const _updatecustomer = async (input) => {

		const updatequery = `mutation ($customerInput: CustomerInput!){
			updateCustomer(input: $customerInput) {
				customer {
					consent_bat_agreement 
					consent_terms_use
					opt_in_email
					opt_in_sms
				}
			}
		}`


		const variablesObj = { customerInput: { "consent_bat_agreement": input.consent_bat_agreement, "consent_terms_use": input.consent_terms_use, "opt_in_email": input.opt_in_email, "opt_in_sms": input.opt_in_sms } }

		const query = JSON.stringify({
			query: updatequery,
			variables: variablesObj
		});
		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		return request;

	}

	const _updatecustomerv2 = async (input) => {

		const updatequery = `mutation ($customerInput: CustomerInput!){
			updateCustomer(input: $customerInput) {
				customer {
					consent_bat_use_personal_info
					opt_in_email
					opt_in_sms
				}
			}
		}`


		const variablesObj = { customerInput: { "opt_in_email": input.opt_in_email, "opt_in_sms": input.opt_in_sms, "consent_bat_use_personal_info": input.consent_bat_use_personal_info } }

		const query = JSON.stringify({
			query: updatequery,
			variables: variablesObj
		});
		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		return request;

	}
	const _getCategoryList = async (categoryId) => {
		const requestBody = `{
			categoryList (
				filters: {
					ids: {
						eq: "${categoryId}"
					}
				}
			) {
				${categoryListInterfaceKR}
			}
			
		}`;

		const request = await _makeGetRequestWithAuthentication(requestBody, "", credentials.INCLUDE).then((response) => {
			Utils.setLocalStorage('commerce-product-storage', response);
			return response;
		});

		return request;
	};

	// Get Product Catalog
	const _getProductCatalog = async (
		categoryIds,
		filterProps,
		productSKU,
		currentPage,
		pageSize,
		sortParam,
		priceRange,
		searchString
	) => {

		createCategoriesString = (categories) => {
			let string = '';
			let el = '';
			if (categories) {
				categories.forEach((category) => (string += `"${category}",`));

				if (string.split(",").length - 1 === 1) {
					el = 'eq';
				} else {
					string = `[${string}]`;
					el = 'in';
				}
				return `
					category_id: {
						${el}: ${string}
					}
				`;
			}
			return string;
		};

		createPropertiesString = (properties) => {
			let string = '';
			if (properties) {
				const propertiesObject = !!properties &&
					properties.reduce((acc, cur) => {
						return !acc[cur.filterProp] ? {
							...acc,
							[cur.filterProp]: `"${cur.filterValue}",`,
						} : {
							...acc,
							[cur.filterProp]: (acc[
								cur.filterProp
							] += `"${cur.filterValue}",`),
						};
					}, {});
				Object.keys(propertiesObject).forEach(
					(key) =>
						(string += `${key}: { in: [${propertiesObject[key]}] }`)
				);
			}
			return string;
		};

		createSKUstring = (sku) => {
			let string = '';
			if (sku) {
				string = `sku: {eq: "${sku}"}`;
			}
			return string;
		};

		createPriceRangeString = () => {
			let string = '';
			if (priceRange) {
				string = `
					price: {
						from: "${priceRange.from}"
						to: "${priceRange.to}"
					}
				`;
			}
			return string;
		};

		createSearchString = () => {
			let string = '';
			if (searchString) {
				string = `search: "${searchString}"`;
			}
			return string;
		};

		const requestBody = `{
			products(
				filter: {
					${createCategoriesString(categoryIds)}
					${createPropertiesString(filterProps)}
					${createSKUstring(productSKU)}
					${createPriceRangeString()}
				}
				${createSearchString()}
				${(sortParam && sortParam.sortProp && sortParam.sortDir) ? `sort : { ${sortParam.sortProp}:${sortParam.sortDir}}` : ''}

				currentPage: ${currentPage}
				pageSize: ${pageSize}
			) {
				items 	{
					${window.quizResultsAttributes !== undefined ? window.quizResultsAttributes : ''}
					${productPropertiesInterfaceKR}
					${isDiscontinued}
					${customProductPropertiesInterfaceKR}
					${relatedProductsInterfaceKR}
					${configurableInterfaceKR}
					${bundleInterfaceKR}
				}
				total_count
				page_info {
					current_page
					page_size
					total_pages
				}
			}
		}`;

		const query = JSON.stringify({
			query: requestBody
		});
		// const request = await _makeGetRequestWithAuthentication(requestBody, "", credentials.INCLUDE).then((response) => {
		// 	Utils.setLocalStorage('commerce-product-storage', response);
		// 	return response;
		// });

		const request = await _makePostRequest(query).then((response) => {
			Utils.setLocalStorage('commerce-product-storage', response);
			return response;
		});


		// const request = await _makePostRequest(query).then((response) => {
		// 	Utils.cartObject('commerce-product-storage', response);
		// 	return response;
		// });

		return request;
	};

	const _getStoreConfig = async () => {
		const requestBody = `{ storeConfig {
    		bat_barometer_config_values
    		}
		}`;
		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makePostRequest(query);


		// const query = JSON.stringify({
		// 	query: requestBody,
		// });
		//
		// const request = await _makeGetRequest(requestBody, "", credentials.INCLUDE);
		return request;
	};

	// Get One Product
	const _getProduct = async (productID) => {
		// Catch no productId.
		if (!productID) {
			return Promise.resolve('Need Product Id.');
		}
		const requestBody = `{
		    products(
		        filter: { sku: {eq: "${productID}"} }
		    ) {
		        items {
					${productPropertiesInterfaceKR}
					${isDiscontinued}
					${customProductPropertiesInterfaceKR}
					${configurableInterfaceKR}
					${bundleInterfaceKR}
		        }
		    }
		}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makePostRequest(query);

		// const request = await _makePostRequest(query, credentials.INCLUDE);
		return request;
	};

	/* Add Simple Product to Cart */
	const _addSimpleProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}
		let requestBody;
		let samplesObj = '';
		if (cartObject.sampleSku != '' && typeof cartObject.sampleSku !== 'undefined') {
			samplesObj = '{data: {quantity: 1 sku: "' + cartObject.sampleSku + '" }}';
		}
		if (cartObject.subscription_option_value === 'subscription') {
			requestBody = `mutation addSimpleProductToCart(
				$cartId: String!
				$sku: String!
				$quantity: Float!
				$subscription_option_value:String!
			) {
				addSimpleProductsToCart(
					input: {
						cart_id: $cartId
						cart_items: [{ data: { quantity: $quantity, sku: $sku }
							subscription_option: {
								option:$subscription_option_value
							}
						},
						${samplesObj}
						]
					}
				) {
					cart {
						items {
							id
							product {
								name
								sku
							}
							quantity
						}
					}
				}
			}`;
		} else {
			requestBody = `mutation addSimpleProductToCart(
				$cartId: String!
				$sku: String!
				$quantity: Float!
			) {
				addSimpleProductsToCart(
					input: {
						cart_id: $cartId
						cart_items: [{ data: { quantity: $quantity, sku: $sku } }, ${samplesObj}]
					}
				) {
					cart {
						items {
							id
							product {
								name
								sku
							}
							quantity
						}
					}
				}
			}`;
		}

		//subscription_option_value: cartObject.subscription_option_value,
		let variablesObj = {
			cartId: cartObject.cartId,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
		};

		if (cartObject.subscription_option_value === 'subscription') {
			variablesObj.subscription_option_value = cartObject.subscription_option_value;
		}

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		return request;
	};

	/* Add Configurable Product to Cart */
	const _addConfigurableProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}

		const requestBody = `mutation addConfigurableProductToCart(
			$cartId: String!
			$parentSku: String!
			$sku: String!
			$quantity: Float!
		) {
			addConfigurableProductsToCart(
				input: {
					cart_id: $cartId
					cart_items: [
						{
							parent_id: $parentSku
							data: { quantity: $quantity, sku: $sku }
						}
					]
				}
			) {
				cart {
					items {
						id
						quantity
						product {
							name
							sku
						}
						... on ConfigurableCartItem {
							configurable_options {
								option_label
							}
						}
					}
				}
			}
		}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			parentSku: cartObject.familySku,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		return request;
	};

	/* Add Bundle Product to Cart */
	const _addBundleProduct = async (cartObject) => {
		// Catch no productId.
		if (!cartObject) {
			return Promise.resolve('Need Cart Object.');
		}

		const requestBody = `mutation addBundleProductToCart(
			$cartId: String!
			$sku: String!
			$quantity: Float!
			$bundleOptions: [BundleOptionInput]!
		) {
			addBundleProductsToCart(
				input: {
					cart_id: $cartId
					cart_items: [
						{
							data: { sku: $sku, quantity: $quantity }
							bundle_options: $bundleOptions
						}
					]
				}
			) {
				cart {
					items {
						id
						quantity
						product {
							sku
						}
						... on BundleCartItem {
							bundle_options {
								id
								label
								type
								values {
									id
									label
									price
									quantity
								}
							}
						}
					}
				}
			}
		}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			sku: cartObject.productSku,
			quantity: cartObject.productQuantity,
			bundleOptions: cartObject.bundleOptions,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);

		return request;
	};

	/* Product Price Formatter */
	const _priceFormatter = (priceValue, priceType) => {
		let price = '';
		let brand = '';

		if (document.getElementsByTagName('meta').brandPage) {
			brand = document.getElementsByTagName('meta').brandPage.content;
		} else if (document.getElementsByTagName('meta').brandPLP) {
			brand = document.getElementsByTagName('meta').brandPLP.content;
		} else if (document.getElementsByTagName('meta').brandPDP) {
			brand = document.getElementsByTagName('meta').brandPDP.content;
		}

		switch (priceType) {
			case 'USD':
				price = `$${priceValue}`;
				break;
			case 'GBP':
				price = `&#163;${priceValue}`;
				break;
			case 'EUR':
				price = `€${priceValue}`;
				break;
			case 'KRW':
				price = `${Utils.toCommas(priceValue)}원`;
				break;
			case 'JPY':
				brand === 'velo' ? price = `${Utils.toCommas(priceValue)}円` : price = `${Utils.toCommas(priceValue)}円 (税込)`; // //(税込)
				// price = `${Utils.toCommas(priceValue)}円`; //(税込)
				break;
			default:
				price = priceValue;
		}

		return price;
	};

	/**
	 * Set Cart ID and Cart Data if present
	 * @params  param - states from user action (refer userStatus)
	 */
	const _setCartDetails = async (param) => {

		if (param === userStatus.RESETCART || param == userStatus.AUTH) {
			_deleteCookie('commerce-cart-id');
			localStorage.removeItem('commerce-cart-storage');
			_deleteCookie('local-cart');
		}
		
		let request;
		const responseCallBack = (response) => {
			if (response.data?.hasOwnProperty('customerCart')) {
				response.data.cart = response.data.customerCart;
				if (_getCookieVal('commerce-cart-id') && _getCookieVal('commerce-cart-id') != undefined) {
					// console.log('Cookie exists');
				} else {
					CommerceKR.setCookieVal('commerce-cart-id', response.data?.cart.id, 1, 'Lax');
				}
			}

			// Add info on user action for messagebar
			response.lastItemAdded = lastItemAdded;
			response.lastActionTaken = lastActionTaken;
			response.data.cart.items = response.data?.cart.items.filter((item) => item !== null);
			CommerceKR.setLocalStorageItem('commerce-cart-storage', response);
			return response;
		};

		let requestBody = '';
		let cartInterfaceKRVal = _cartInteraceKR();
		requestBody = `{
			customerCart {
			  id
			  ${cartInterfaceKRVal}
			}
		  }`;
		const query = JSON.stringify({
			query: requestBody,
		});

		request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE).then(responseCallBack);

		return request;

	};

	/**
	 * Method to verify user and cart initialization call
	 * @params  bool - page redirection
	 * 			optionmsg - Text to show in a toast // Todo
	 * 			source - Source of the call (refer appCartInitSource)
	 */
	const _verifyCart = (redirect, optionmsg, source, updateCart) => {
		let isLoggedIn = _isLoggedInUser();
		let existingCartID = _getCookieVal('commerce-cart-id');

		if (isLoggedIn && updateCart) {
			return CommerceKR.setCartDetails(userStatus.RESETCART);
		}

		if (source == appCartInitSource.DEFAULT && isLoggedIn && existingCartID) {
			return CommerceKR.fetchCart(existingCartID, true, false);
		} else if (source == appCartInitSource.AUTH) {
			//return true;
			console.log('Continue cart set process');
			// TODO: Console will be removed after gated access implementation
		} else if ((source == appCartInitSource.CART || source == appCartInitSource.PLPPDP) && isLoggedIn && existingCartID) {
			return CommerceKR.fetchCart(existingCartID, true, true);
		}

		if (isLoggedIn) {
			if (existingCartID == null || existingCartID == '') {
				return CommerceKR.setCartDetails(userStatus.AUTH);
			} else {
				//return true;
				if (source != appCartInitSource.CART || source != appCartInitSource.PLPPDP) {
					return CommerceKR.setCartDetails(userStatus.RESETCART);
				} else {
					return CommerceKR.setCartDetails(userStatus.NOREDIRECT);
				}
			}
		} else {
			if (optionmsg != undefined && optionmsg != null && optionmsg != '') {
				if (redirect) {
					// return _showToast(redirect);
					return _checkPageRedirect(true, 'login', '', 'sessionexp');
				} else {
					return false;
				}
			} else {
				return _checkPageRedirect(redirect, '', '');
			}
		}

	};

	/**
	 * Global toast display method // Work in Progress
	 * @params  redirect - page redirection
	 * 			page - page to redirect - default : login
	 * 			msg - Text to show in a toast // Todo
	 */
	const _showToast = async (redirect, page, msg) => {
		let toastEl = '';
		const findEl = $('.bat-form-toast_wrapper');

		if (findEl.length == 0) {
			const elDiv = $("div");
			elDiv.attr({
				'class': 'bat-form-toast_wrapper',
				'id': 'batFormToast'
			});
			const elDivInner = $("div");
			elDivInner.addClass('bat-form-toast_wrapper-toast');
			const elDivInnerContentWrapper = $("div");
			elDivInnerContentWrapper.addClass('bat-form-toast_wrapper-toast-right');
			const elDivInnerContent = $("span");
			elDivInnerContent.addClass('bat-form-toast_wrapper-toast-right-content');
			elDivInnerContent.html("Please login to continue");

			elDivInnerContentWrapper.append(elDivInnerContent);
			elDivInner.append(elDivInnerContentWrapper);
			elDiv.append(elDivInner);
			$('body').append(elDiv);

			if (!redirect) {
				$('#batFormToast').css('display', 'block');
				setTimeout(() => {
					$('#batFormToast').css('display', 'none');
				}, 5000);
				return false;
			} else {
				$('#batFormToast').css('display', 'block');
				setTimeout(() => {
					$('#batFormToast').css('display', 'none');
					return _checkPageRedirect(redirect);
				}, 2000);
			}
		} else {
			return _checkPageRedirect(redirect);
		}
	};

	// const _redirectToGatedPage() {
	// 	window.location.href = window.location.protocol + "//" + window.location.host
	// }

	/**
	 * Method to check the page rediection request and show message
	 * @params  bool - page redirection
	 * 			page - page to redirect - default : login
	 * 			msg - Text to show in a toast // Todo
	 * 			showparam - Send params on redirection
	 * 			checkAuthorMode - whether to check author mode : boolean
	 * 			source - Source of the call (refer appCartInitSource)
	 * 			forceRedirect - Ignore all and force redirect to login : boolean
	 */
	const _checkPageRedirect = (bool, page, msg, showparam, checkAuthorMode, source, forceRedirect) => {
		const isAuthorMode = CommerceKR.isAuthorMode();
		const isAuthenticated = CommerceKR.isLoggedInUser();
		let redirectToLogin = false;
		const url = window.location.href;
		const isUngatedPage = CommerceKR.isUngatedPage(url);
		const isGuestUser = CommerceKR.isGuestUser()

        const country = document.body.dataset.country;
        const language = document.body.dataset.language;

		if (checkAuthorMode && isAuthorMode) {
			return false;
		}

		if ((!isAuthenticated && !isUngatedPage && !isAuthorMode && !isGuestUser) || (forceRedirect != undefined && forceRedirect)) {
			redirectToLogin = true;
		}
		let windowPathArr = window.location.pathname.split('/');
		windowPathArr.pop(windowPathArr.length - 1);
		let windowPathName = windowPathArr.join('/');
		let redirectUrl = window.location.protocol + "//" + window.location.host + windowPathName;
		let searchparams = (window.location.search != '') ? window.location.search + '&' : '?';

		let domainOrigin = `${window.location.origin}/${country}/${language}`;

		if (page !== undefined && page !== '' && page !== 'login') {
			const countryLanguageString = `/${country}/${language}`;
			
			if (!redirectUrl.endsWith(countryLanguageString)) {
				redirectUrl += countryLanguageString;
			}

			if (page === 'account-details') {
				redirectUrl = redirectUrl + '/account/' + page;
			} else {
				redirectUrl = redirectUrl + '/' + page;
			}
		} else {
			if (page === 'home') {
				redirectUrl = domainOrigin + '/home';
			} else if (page === 'account-details') {
				redirectUrl = domainOrigin + '/account/' + page;
			} else if (page === 'gated') {
				redirectUrl = domainOrigin + '/gated/';
			} else {
				redirectUrl = domainOrigin + '/gated';
			}
		}

		if (showparam) {
			redirectUrl = redirectUrl + searchparams + showparam + '=true';
		}

		if (msg) {
			CommerceKR.setLocalStorageItem('temp-msg-key', msg);
		}

		if ((!isUngatedPage && bool != undefined && bool && !isAuthorMode) || redirectToLogin ||
			(source != undefined && source == appCartInitSource.PLPPDP) || (isUngatedPage && isAuthenticated)) {
			if(!isAuthorMode) {
				window.location.href = redirectUrl;
			}
			return true;
		}
	};

	/**
	 * Initialise Cart
	 * @params  redirect - Whether there will be a redirection
	 * 			source - Source of the call (refer appCartInitSource)
	 */
	const _initCart = async (redirect, source) => {

		// Verify the rules for cart first
		return CommerceKR.verifyCart(redirect, '', source);
	};

	/**
	 * Ftech the Cart details
	 * @params  cartId - fetched cart id from cookie or another response
	 * 			auth - If the user is authorized
	 * 			callapi - whether to fetch the cart details from local storage or graphql mutation
	 */
	const _fetchCart = async (cartId, auth, callapi) => {
		let cartObj = '';
		if (callapi) {
			cartObj = await CommerceKR.setCartDetails(userStatus.AUTH);
		} else {
			cartObj = JSON.parse(localStorage.getItem('commerce-cart-storage'));
		}
		return cartObj;
	};

	/**
	 * Get the Cart details and send back the response
	 * @params  cartId - fetched cart id from cookie or another response
	 * 			reload - page redirection - passed on to verifyCart
	 * 			optionmsg - Text to show in a toast // Todo
	 * 			source - Source of the call (refer appCartInitSource)
	 * 			checkAuthorMode - Whether to check authoring mode : boolean
	 */
	const _getCart = async (cartId, reload, optionmsg, source, checkAuthorMode) => {
		let isUserLoggedIn = _isLoggedInUser();
		let responseCallback = '';
		if (isUserLoggedIn) {
			if (cartId) {
				responseCallback = await CommerceKR.setCartDetails(userStatus.RESETCART);
			} else {
				responseCallback = await CommerceKR.setCartDetails(userStatus.AUTH);
			}
		} else {
			if (source == appCartInitSource.CART) {
				// This is placeholder for handling gated access
				responseCallback = _checkPageRedirect(true, 'login', '', 'sessionexp', checkAuthorMode);
			} else {
				responseCallback = await CommerceKR.verifyCart(reload, optionmsg, appCartInitSource.DEFAULT);
			}
		}

		return responseCallback;
	};

	/* Merge local and remote carts */
	const _replaceCommerceCart = async (guestCartId) => {
		const requestBody = `mutation {
								assignGuestCartToCustomer(
									input: {
										cart_id: "${guestCartId}"
									}
								) {
									 cart {
										items {
											id
											quantity
											product {
												sku
												stock_status
											}
										}
									}
									error_messages {
										message
									}
								}
							}`;


		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makePostRequest(query).then((response) => {
			return response.data;
		});
		Utils.eraseCookie('local-cart');
		Utils.removeLocalStorage('commerce-cart-storage');
		Utils.eraseCookie('commerce-cart-id');

		if (request && request.errors) {
			$(window).trigger(cartError, request.errors[0].message);
			return request;
		}

		return request;
	};

	/* Get Cart Id on page load */
	const _getCartId = async (cartId) => {

		let isLoggedInUsr = _isLoggedInUser();
		let existingCartID = '';

		if (Utils !== undefined) {
			existingCartID = Utils.getCookie('commerce-cart-id');
		} else {
			existingCartID = _getCookieVal('commerce-cart-id');
		}

		if (isLoggedInUsr) {
			if (existingCartID == null || existingCartID == '') {
				return CommerceKR.setCartDetails(userStatus.AUTH);
			} else {
				return CommerceKR.setCartDetails(userStatus.RESETCART);
			}
		} else {
			return CommerceKR.checkPageRedirect(true, 'login', '', 'sessionexp');
		}

	};

	const _isLoggedIn = () => {
		return false;
	}

	/* Check the logged in user */
	const _isLoggedInUser = () => {
		const authcookie = getCookie('commerce-auth-token');
		//const authVerify = getCookie('commerce-auth-verify');

		if (authcookie) {
			return true;
		} else {
			return false;
		}
	}

	/* Check the autjoring mode */
	const _isAuthorMode = () => {
		const authorCookie = _getCookieVal('cq-authoring-mode');
		if (authorCookie) {
			return true;
		} else {
			return false;
		}
	}

	/* Check from array of gated pages */
	const _isUngatedPage = (url) => {
		console.log("test ungated")
		let returnVal = false;

		if (document.getElementsByTagName('meta').nonLogged) {
			returnVal = true;
		}

		return returnVal;
	}

	/* Update Phone Number */
	const _phoneNumberFormat = (value) => {
		if (value) {
			let pattern;
			value = value.replace(/[^\d]/g, "");

			if (value.length == 10) {
				if (value.substr(0, 4) == '8210') {
					pattern = /(\d{4})(\d{3})(\d{3})/;
				} else {
					pattern = /(\d{3})(\d{3})(\d{4})/;
				}
			} else if (value.length == 11) {
				if (value.substr(0, 4) == '8210') {
					pattern = /(\d{4})(\d{3})(\d{4})/;
				} else {
					pattern = /(\d{3})(\d{4})(\d{4})/;
				}
			} else if (value.length == 12) {
				if (value.substr(0, 4) == '8210') {
					pattern = /(\d{4})(\d{4})(\d{4})/;
				}
			}
			return value.replace(pattern, "$1-$2-$3");
		}
	}

	/* Create Empty Cart */
	const _createEmptyCart = async () => {
		const requestBody = 'mutation {createEmptyCart}';
		const query = JSON.stringify({
			query: requestBody
		});

		const request = await _makePostRequest(query).then((response) => {
			Utils.setCookie('commerce-cart-id', response.data.createEmptyCart, 1, 'Lax');
			Utils.setCookie('local-cart', true, 1, 'Lax');
			return response.data.createEmptyCart;
		});

		return request;
	};

	/* Remove Item From Cart */
	const _removeItemFromCart = async (cartItemId) => {
		const cartId = Utils.getCookie('commerce-cart-id');
		// Trigger cart update window event
		$(window).trigger(cartAction);

		// If no cartId or no cartItemId.
		if (!cartId || !cartItemId) {
			return Promise.resolve('Need cartId and cartItemId.');
		}

		const requestBody = `mutation removeItemFromCart($cartId: String!, $cartItemId: Int!) {
			removeItemFromCart(input: { cart_id: $cartId, cart_item_id: $cartItemId }) {
				cart {
					${cartInterfaceKR}
				}
			}
		}`;

		const variablesObj = {
			cartId,
			cartItemId,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);

		/* eslint-disable-next-line no-console */
		console.log('removeItemFromCart', request);

		// Update local storage
		lastActionTaken = 'remove';
		await _getCart(cartId, true, '', appCartInitSource.CART);
		$(window).trigger(cartUpdate);
		return request;
	};

	/* Update Item From Cart */
	const _updateItemInCart = async (cartItemId, quantity) => {
		const cartId = Utils.getCookie('commerce-cart-id');

		// Trigger cart update window event
		$(window).trigger(cartAction);

		// If no cartId, cartItemId and cartItemQuantity.
		if (!cartId || !cartItemId || !quantity) {
			return Promise.resolve('Need cartId, cartItemId and quantity.');
		}

		const requestBody = `mutation updateCartItem(
			$cartId: String!
			$cartItemId: Int!
			$quantity: Float!
		) {
			updateCartItems(
				input: {
					cart_id: $cartId
					cart_items: [{ cart_item_id: $cartItemId, quantity: $quantity }]
				}
			) {
				cart {
					${cartInterfaceKR}
				}
			}
		}`;

		const variablesObj = {
			cartId,
			cartItemId,
			quantity,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);

		// Update local storage
		lastActionTaken = 'update';
		//await _verifyCart(false, '', appCartInitSource.CART, true);

		await _getCart(cartId, true, '', appCartInitSource.CART);

		$(window).trigger(cartUpdate);

		return request;
	};

	/* Add Item To Cart */
	const _addItemToCart = async (productObject, checkAuthorMode) => {
		let cartId = Utils.getCookie('commerce-cart-id');
		let cartObject = productObject;
		//console.log('adding following to the cart');
		//console.log(cartObject);
		// saving item for carts merge after logging in
		if (!_isLoggedInUser()) {
			return _checkPageRedirect(true, 'login', '', 'sessionexp');
		}
		// Trigger cart update window event
		// $(window).trigger(cartAction);

		// Set cart item Name for message bar
		lastActionTaken = 'add';
		lastItemAdded = cartObject.productName;
		// Utils.setCookie('commerce-item-message', cartObject.productName);

		// If no cartId, create one.
		if (!cartId) {
			const cart = await _getCart('', false, '', appCartInitSource.CART, checkAuthorMode);
			if (!cart || cart == undefined || cart == null) {
				console.log(' No need to call getCart')
				return Promise.resolve('Need Cart');
			} else {
				cartId = cart?.data?.cart.id;
			}
		}

		cartObject = {
			...cartObject,
			cartId,
		};

		/* eslint-disable-next-line no-console */
		console.log('addItemToCart cartId', cartObject);

		let request;

		switch (cartObject.productType) {
			case 'simple':
				request = await _addSimpleProduct(cartObject);
				break;
			case 'configurable':
				request = await _addSimpleProduct(cartObject);
				break;
			case 'bundle':
				request = await _addBundleProduct(cartObject);
				break;
			default:
		}

		if (request && request.errors) {
			return request;
		}

		await _verifyCart(false, '', appCartInitSource.CART, true);

		const cart = await _fetchCart(cartId, true, false);
		$(window).trigger(cartUpdate);

		//analytics code addToCart event
		const currItem = cart.data.cart.items[cart.data.cart.items.length - 1];
		if (!window.digitalData.hasOwnProperty('ecommerce')) {
			analyticsDataLayer.resetWindowCommerceObject();
		}


		if (currItem) {
			window.digitalData.ecommerce.add.product = [];
			analyticsDataLayer.populateAddToCartObj(currItem, cartId);
		}

		return cart;
	};

	const _checkForPendingPayment = async () => {
		const query = `{ getOrderStatusPendingPaymentForCustomer{ order_id } }`;

		const { data } = await CommerceKR.makePostRequestWithAuthentication(
			JSON.stringify({
				query,
			})
		); 
		 
	}
 

	/* Get Cart Total Quantity */
	const _getCartQuantity = async () => {

		let authcookie = CommerceKR.getCookieVal('commerce-auth-token');

		if (!authcookie) {
			return false;
		}

		let localCart = JSON.parse(localStorage.getItem('commerce-cart-storage'));

		// if no cart storage then create one
		if (!localCart) {
			await _getCustomerDetails();
			let cartId = Utils.getCookie('commerce-cart-id');
			await _getCart(cartId, false, '', appCartInitSource.CART);
			localCart = JSON.parse(localStorage.getItem('commerce-cart-storage'));
		}

		let cartQuantity = 0;

		if (localCart && localCart.data.cart.items.length > 0) {
			cartQuantity = localCart.data.cart.items
				.map((item) => {
					return item.quantity ? parseInt(item.quantity) : parseInt(item.productQuantity);
				})
				.reduce((prev, next) => {
					return prev + next;
				});
		}
		if(cartQuantity === 0) {
			await CommerceKR.checkForPendingPayment();
			let authcookie = CommerceKR.getCookieVal('commerce-auth-token');
			if (!authcookie) {
				return false;
			}
			let localCart = JSON.parse(localStorage.getItem('commerce-cart-storage'));
			// if no cart storage then create one
			if (!localCart) {
				await _getCustomerDetails();
				let cartId = Utils.getCookie('commerce-cart-id');
				await _getCart(cartId, false, '', appCartInitSource.CART);
				localCart = JSON.parse(localStorage.getItem('commerce-cart-storage'));
			}
			let cartQuantity = 0;
			if (localCart && localCart.data.cart.items.length > 0) {
				cartQuantity = localCart.data.cart.items
					.map((item) => {
						return item.quantity ? parseInt(item.quantity) : parseInt(item.productQuantity);
					})
					.reduce((prev, next) => {
						return prev + next;
					});
			}
			return cartQuantity;
		}
		return cartQuantity;
	};

	/* Get Product Alerts */
	const _getProductAlerts = async () => {
		const requestBody = `{
			  productAlert {
				 product_id
				 status
			  }
		   }`;

		const request = await _makeGetRequestWithAuthentication(
			requestBody,
			'',
			credentials.INCLUDE
		);
		return request;
	};

	/* Add Product Alert */
	const _addProductAlert = async (productId) => {
		// Catch no productId.
		let isLoggedIn = _isLoggedInUser();
		if (!productId) {
			return Promise.resolve('Need productId.');
		}

		// Check if the user is logged in
		if (!isLoggedIn) {
			return _checkPageRedirect(true, 'login', '', 'sessionexp');
			//return Promise.resolve('login needed.');
		}


		const requestBody = `mutation productAlertCustomerNotifyInStock(
			$productId: Int!
		) {
			productAlertCustomerNotifyInStock(
				input: {
					productId: $productId
				}
			) {
				product_id
				status
			}
		}`;

		const variablesObj = {
			productId,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		return request;
	};

	/**
	 * Login method for the application
	 * @params  email - user email
	 * 			password - user password value
	 */
	const _loginKr = async (email, password) => {
		const requestBody = ` mutation {
			generateCustomerToken(email: "${email}", password: "${password}") {
				token
				refreshToken
			}
		}`;

		let initCartVar = '';

		const query = JSON.stringify({
			query: requestBody
		});

		return await _makePostRequest(query).then((response) => {
			const customerToken = response?.data?.generateCustomerToken?.token;

			if (customerToken) {
				const authToken = response.data.generateCustomerToken.token;
				const refreshToken = response.data.generateCustomerToken.refreshToken;

				// Setting cookie alive till M2 expiration time
				Utils.setCookieKR('commerce-auth-token', authToken, 59);
				Utils.setCookieKR('commerce-auth-refresh-token', refreshToken, 120);
	
				localStorage.removeItem("is_guest_user");
				// Initialise cart with redirection true
				initCartVar = CommerceKR.initCart(true, appCartInitSource.AUTH);
				return initCartVar;
			} else {
				return response;
			}
		});


	};


	/**
	 * Token Regeneration method for the application
	 * @params  refToken - Refresh token
	 */
	const _regenerateToken = async (refToken) => {
		const requestBody = ` mutation {
			reissueCustomerToken(refreshToken: "${refToken}") {
				token
				refreshToken
			}
		}`;

		const query = JSON.stringify({
			query: requestBody
		});

		return await _makePostRequest(query).then((response) => {
			const customerToken = response?.data?.reissueCustomerToken?.token;
			if (response.errors && response.errors.length) {
				if (response.errors[0].extensions.category == "graphql-authorization" && (response.errors[0].message == "Token is expired" || response.errors[0].message == "Invalid refresh token")) {
					Utils.eraseCookie('commerce-auth-token');
					return false;
				}
			}

			if (customerToken) {
				const authToken = response.data.reissueCustomerToken.token;
				const refreshToken = response.data.reissueCustomerToken.refreshToken;
				Utils.eraseCookie('commerce-auth-token');
				Utils.eraseCookie('commerce-auth-refresh-token');
				localStorage.removeItem("is_guest_user");

				// Setting cookie alive till M2 expiration time
				Utils.setCookieKR('commerce-auth-token', authToken, 59);
				Utils.setCookieKR('commerce-auth-refresh-token', refreshToken, 120);

				return true;
			}
		});

	};


	const _logoutUser = async (url) => {
		const requestBody = `mutation {
			revokeCustomerToken {
			  result
			}
		}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const isLogout = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);
		if (isLogout) {
			Utils.eraseCookie('commerce-auth-token');
			Utils.eraseCookie('is-kakao-user');
			Utils.removeLocalStorage('transaction_id');
			Utils.removeLocalStorage('danal_verified');
			window.location.replace(url);
		}
	};
	//Kakao Login Cookie 
	const _loginKrKakao = async (kakaoToken , refreshToken) => {
		let initCartVar = '';
		const customerToken = kakaoToken;

		if (customerToken) {
			const regenerateToken = refreshToken;

			// Setting cookie alive till M2 expiration time
			Utils.setCookieKR('commerce-auth-token', customerToken, 59);
			Utils.setCookieKR('commerce-auth-refresh-token', regenerateToken, 120);

			localStorage.removeItem("is_guest_user")

			// Initialise cart with redirection true
			initCartVar = CommerceKR.initCart(true, appCartInitSource.AUTH);

            console.log('Check if setUrl present...');
			const isUrlSet = localStorage.getItem("setUrl");
			if (isUrlSet){
				console.log('setUrl is present');
				window.location.href = localStorage.getItem("setUrl");
				localStorage.removeItem("setUrl");
				return;
			}
			_checkPageRedirect(true, 'home', '', '', '', '', true);

		} else {
			return response;
		}
	};

	/* Resend Mail confirmation */
	const _resendMailAccountConfirmation = async (email) => {

		const requestBody = `mutation {
			resendConfirmationEmail(email: "${email}")
		  }`;

		const query = JSON.stringify({
			query: requestBody
		});

		const response = await _makePostRequest(query);
		const mailSendStatus = response?.data;

		return mailSendStatus;
	};

	/**
	 * Date Of Birth Masking
	 * @params  el - Keyup Event
	 */
	 const _checkDOBFormat = (el) => {
		const len = $(el.target).val().length;
		const allowedKeyArr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "Backspace"];
		
		if (allowedKeyArr.indexOf(el.key) != -1 && el.key != "/") {
			el.preventDefault();
		}

		if (len === 4 && el.code.indexOf("Backspace") == -1) {
			$(el.target).val($(el.target).val() + '/');
		}

		if (len === 7 && el.code.indexOf("Backspace") == -1) {
			$(el.target).val($(el.target).val() + '/');
		}

		if(($(el.target).val()).match(/\//g) != null && ($(el.target).val()).match(/\//g).length > 1 && len > 4 & len < 7){
			let temp = $(el.target).val();
			temp = temp.replace('/','');
			$(el.target).val(temp);
		}
	}

	const _addProductReview = async (reviewObject) => {
		const ratings = reviewObject.ratings.reduce(
			(acc, cur) =>
				`${acc}{id: "${cur.id}", value_id: "${cur.value_id}"},`,
			''
		);

		const product_variant_options = reviewObject?.product_variant_options?.reduce(
			(acc, cur) =>
				`${acc}{option_id: ${cur.option_id}, product_id: ${cur.product_id}},`,
			''
		)


		const requestBody = product_variant_options ? `
				mutation {
					createProductReview (
						input: {
							sku: "${reviewObject.sku}",
							nickname: "${reviewObject.nickname}",
							summary: "${reviewObject.summary}",
							text: "${reviewObject.text}",
							ratings: [${ratings}],
							product_variant_options: [${product_variant_options}] 
						}
					) {
					review {
						nickname
						summary
						text
						average_rating
						ratings_breakdown {
							name
							value
						}
					}
				}
			}
		` :
			`
				mutation {
					createProductReview (
						input: {
							sku: "${reviewObject.sku}",
							nickname: "${reviewObject.nickname}",
							summary: "${reviewObject.summary}",
							text: "${reviewObject.text}",
							ratings: [${ratings}],
						}
					) {
					review {
						nickname
						summary
						text
						average_rating
						ratings_breakdown {
							name
							value
						}
					}
				}
			}
		`


		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.SAMEORIGIN);
		return request;
	};

	const _getProductReviews = async (productID) => {
		// Catch no productId.
		if (!productID) {
			return Promise.resolve('Need Product Id.');
		}
		const requestBody = `{
		    products(
		        filter: { sku: {eq: "${productID}"} }
		    ) {
		        items {
					${productReviewsInterfaceKR}
		        }
		    }
		}`;
		const request = await _makeGetRequest(requestBody);
		return request;
	};

	/* Get Customer Details */
	const _getCustomerDetails = async () => {
		const requestBody = `{
			customer {
			entity_id
			firstname
			lastname
			suffix
			email
			telephone
			dob
			gender
			gigya_id
			velo_member_id
			glo_member_id
			gloid
			channel_name
			kakao_su_id
			kakao_user_flag
			confirmation
			has_glo_velo_orders
			glo_velo_history_check {
				glo_kr_device 
			}
			subscription {
				has_subscription
			}
			addresses {
			firstname
			lastname
			street
			city
			region {
			  region_code
			region
			}
			postcode
			country_code
			telephone
			}
			}
			}`;

		const query = JSON.stringify({
			query: requestBody,
		});

		const request = await _makeGetRequestWithAuthentication(requestBody, "", credentials.INCLUDE);
		if (request && !request.errors) {
			Utils.setLocalStorage('hasSubscription', request.data.customer.subscription.has_subscription);
			Utils.setLocalStorage('hasGloVeloOrders', request.data.customer.has_glo_velo_orders);
			Utils.setLocalStorage('gloVeloHistoryCheck', request.data.customer.glo_velo_history_check);
		}
		return request;
	};

	// save basket exclusivity items for later
	const _getExclusivityItems = async (cartObject) => {

		const requestBody = `mutation saveBasketExclusivityItemsForLater(
			$cartId: String!
			$itemType: String!
		) {
			moveCartItemsToPendingCart(
				input: {
					cart_id: $cartId,
					item_type: $itemType
				}
			) {
				cart {
					items {
						id
							product {
							name
							sku
							}
						quantity
					}
				}
				}
			}`;

		const variablesObj = {
			cartId: cartObject.cartId,
			itemType: cartObject.itemType,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);

		return request;
	};

	// save basket exclusivity items for later new graphql
	const _getExclusivityItemsAem = async (cartObject) => {
		const requestBody = `mutation splitCart(
            $cartId: String!
            $itemType: String!
        ) {
            splitCart(
                input: {
                    cart_id: $cartId,
                    item_type: $itemType
                }) {
                cart {
                    items {
                        id
                        product {
                            name
                            sku
                        }
                        quantity
                    }
                }
                pending_cart_id
            }
        }`;

		const variablesObj = {
			cartId: cartObject.cartId,
			itemType: cartObject.itemType,
		};

		const query = JSON.stringify({
			query: requestBody,
			variables: variablesObj,
		});

		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE);

		return request;
	};

	const _checkIfEligible = async (productId, campaignType, level) => {
		console.log("inside check eligible method", campaignType);
		if (level === 0) {
			levelValue = 'level:0';
		} else if (level === 1) {
			levelValue = 'level:1';
		} else {
			levelValue = 'level:2';
		}
		let requestBody;
		if (campaignType == 'NJC') {
			requestBody = `query {
				newJoinerCampaign(product_id: ${productId}, ${levelValue}) {
					is_allowed
					url
					message
				}
			}`;
		} else if (campaignType == 'PRELAUNCH') {
			requestBody = `query {
				preLaunchCampaign(product_id: ${productId}, ${levelValue}) {
					is_allowed
					url
					message
				}
			}`;
		}
		const request = await _makeGetRequestWithAuthentication(requestBody, "", credentials.INCLUDE).then((response) => {
			return response;
		});

		return request;
	}

	const _sendQuizStatus = async (sessionId, answers, isFinished = 0) => {
		const requestBody = `
							mutation {
							  updateJpGuidedSellResponse(
								input: {
								  session_id: ${sessionId}
								  ${answers !== null ? `reason_indices : ${answers}` : ``}
								  ${isFinished !== 0 ? `finished: true` : ``}
								}
							  ) {
								device
								device_description
								finished
								filters {
								  attribute_code
								  category_id
								  options
								}
							  }
							}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE).then((response) => {

			return response;
		});


		return request;
	}

	const _getQuizQuestions = async (el) => {
		const requestBody = `query {
		  					moduleConfig {
								jp_guided_sell {
								  enabled
								  configuration {
									questions {
									  question
									  options
									}
								  }
								}
							  }
							}`;
		const query = JSON.stringify({
			query: requestBody
		});
		const request = await _makePostRequestWithAuthentication(query, credentials.INCLUDE).then((response) => {
			return response;
		});

		return request;
	}

	/* Cart Interface - Used for customerCart mutation */
	const _cartInteraceKR = () => {

		const productPropertiesInterfaceCartKR = `
			id
			sku
			name
			brand
			subscription {
				is_subscription_enabled
				min_qty
				max_qty
			}
			small_image {
				url
				label
			}
			price_range {
				maximum_price {
					regular_price {
						value
						currency
					}
				}
				minimum_price {
					regular_price {
						value
						currency
					}
					final_price {
						value
						currency
					}
					discount {
						amount_off
						percent_off
					}
				}
			}
			stock_status
			type_id
			max_qty
			glojp_aem_url
			product_code
			comdty_code

		`;

		const customProductPropertiesInterfaceCartKR = `
			jp_bundle_type
			jp_bundle_type_value
			jp_dedicated_device
			jp_dedicated_device_value
			jp_bundle_regular_price
			glo_jp_colour_value 
			glo_jp_category_value
		`;

		const cartInterfaceKRQuery = `
			items (sortBySubscription: SUBSCRIPTION_FIRST) {
				id
				tax_percent
				product {
					${productPropertiesInterfaceCartKR}
					${customProductPropertiesInterfaceCartKR}
					... on BundleProduct {
					items {
						option_id
						options {
						id
						label
						product {
							id
							sku
							brand
							name
							comdty_code
							glojp_aem_url
							stock_status
							jp_bundle_type
							price_range {
							minimum_price {
								final_price {
								value
								currency
								}
							}
							}
						}
						}
					}
					}
				}
				prices {
					discounts {
						label
					}
					row_total_including_tax {
						value
						currency
					}
				}
				... on BundleCartItem {
					bundle_options {
						id
						label
						values {
							id
							label
							quantity
						}
					}
				}
				... on ConfigurableCartItem {
					configurable_options {
						id
						option_label
						value_label
					}
				}
				quantity
				subscription_data {
					is_subscription_item
				}
			}
			prices {
				discounts {
					amount {
						value
						currency
					}
					label
				}
				  okcashbag_points {
					value
					currency
				  }
				grand_total {
					value
					currency
				}
				subtotal_including_tax {
					value
					currency
				}
				
			}
			customprices {
				grand_total_excluding_shipping_payment_fees {
					value
					currency
				}
			}
			total_quantity
		`;
		return cartInterfaceKRQuery;
	}

	const _mapProduct = (product) => {
		function formatPriceString(priceObject) {
			return {
				...priceObject,
				value: typeof priceObject?.value === 'string' ? priceObject?.value : _priceFormatter(priceObject?.value, priceObject?.currency),
			};
		}

		let small_image;
		switch (product.type_id) {
			case 'configurable':
				small_image = product?.variants[0].product.small_image;
				break;
			case 'bundle':
				small_image = product.small_image || product.items[0].options[0].product.small_image;
				break;
			default:
				small_image = product.small_image;
		}

		let price_range = {
			final_price: formatPriceString(product.price_range?.minimum_price?.final_price),
		};

		if (product.price_range?.minimum_price?.discount?.amount_off) {
			price_range = {
				final_price: formatPriceString(product.price_range?.minimum_price?.final_price),
				regular_price: formatPriceString(product.price_range?.minimum_price?.regular_price),
			};
		}

		if (product.type_id === 'bundle' && product.jp_bundle_regular_price) {
			price_range = {
				...price_range, regular_price: formatPriceString({
					value: product.jp_bundle_regular_price,
					currency: product.price_range?.minimum_price?.final_price?.currency,
				}),
			};
		}

		return {
			price_range,
			show_notify_button: product.jp_campaign_any !== true ? (product.type_id !== 'bundle' && product.stock_status === 'OUT_OF_STOCK' && !product.notification_set):"",
			show_notify_set_button: product.jp_campaign_any !== true ? (product.type_id !== 'bundle' && product.stock_status === 'OUT_OF_STOCK' && product.notification_set):"",
			show_link_button: (product.type_id === 'bundle') || (product.stock_status !== 'OUT_OF_STOCK' && product?.variants && product?.variants.length > 5),
			show_cart_button: product.jp_campaign_any !== true ? (product.stock_status !== 'OUT_OF_STOCK' && product.type_id !== 'bundle') || (product.stock_status !== 'OUT_OF_STOCK' && product?.variants && product?.variants.length <= 5):"",
			show_product_button: ((product.jp_campaign_any == true && product.type_id !== 'bundle') && product.jp_campaign_pre_launch !== true),
			show_preorder_button: ((product.jp_campaign_any == true && product.type_id !== 'bundle') && product.jp_campaign_pre_launch === true), // {{ Applicable for Prelaunch Product}}
			showFragrance: Object.keys(product).some((key) => key.includes('glo_strength_fragnance') && !!product.glo_strength_fragnance),
			showTobacco: Object.keys(product).some((key) => key.includes('glo_strength_tobacco') && !!product.glo_strength_tobacco),
			showStrengthMenthol: Object.keys(product).some((key) => key.includes('glo_strength_menthol') && !!product.glo_strength_menthol),
			showStrengthIntake: Object.keys(product).some((key) => key.includes('glo_strength_intake') && !!product.glo_strength_intake),
			small_image,
		};	
	}

	const _mapSelected = (products) => {
		console.log('map selected in commerceKR');
		return products.map((product) => {
			const selectedVariant = product?.variants && product?.variants.find((variant) => !!variant.product.glo_jp_colour);
			const selectedProduct = (selectedVariant && selectedVariant.product) || product;
			return {
					...selectedProduct, 
			        selectedProduct: {
					...selectedProduct, ..._mapProduct(selectedProduct),

				},
			};
		});
	}

		//xIntense modal product load and logic 
		const  _openRcommendenProductModal = async (suggestedSKU) => {
			const modalEl = $('#recommondedsku');
			modalEl.css('padding-top','20px');
			const closeButton = document.querySelector('#recommondedsku .bat-form-toast_wrapper-toast-right-closebutton');
			closeButton.addEventListener("click", () => {
				modalEl.hide();
			});
			const productLoadingProgress = $('.bat-productdetails .loader-container');
			$('#recommondedsku .bat-cta-style.bat-modal-close').hide();
			productLoadingProgress.show();
			let productsData = await _getProduct(suggestedSKU).then((response) => response.data);
			console.log(productsData);
			let filteredSKU = productsData?.products.items.filter(
				(p) => p.sku === suggestedSKU
			);
			console.log('filteredSKU' + filteredSKU.length);
			if(filteredSKU.length<=0) {
				console.log('3no direct sku its configurable product');
				filteredSKU = productsData?.products.items;
			}
			
			productLoadingProgress.hide();
			console.log('recommendedProductKR' + productsData);
			console.log('filtered product2' + filteredSKU);
			let productDetailsData = document.querySelector('bat-card-productdetailskr').data;
			let items = _mapSelected(filteredSKU);
			productDetailsData.items = items;
			document.querySelector('bat-card-productdetailskr').setAttribute("data-model", JSON.stringify(productDetailsData));
			$('#goToRecommendedProduct').attr('href', $('.bat-productdetails .bat-productlistings-card-name a').attr('href'));
			document.querySelector('#recommondedsku .bat-form-toast_wrapper-toast-right-closebutton').addEventListener("click", () => {
				modalEl.hide();
			});
		}



	_constructor();

	// output/public
	return {
		isLoggedIn: _isLoggedIn,
		createEmptyCart: _createEmptyCart,
		checkForPendingPayment: _checkForPendingPayment,
		addItemToCart: _addItemToCart,
		updateItemInCart: _updateItemInCart,
		getCart: _getCart,
		getCartId: _getCartId,
		getCartQuantity: _getCartQuantity,
		removeItemFromCart: _removeItemFromCart, 
		getProduct: _getProduct,
		priceFormatter: _priceFormatter,
		getProductCatalog: _getProductCatalog,
		getCategoryList: _getCategoryList,
		getProductAlerts: _getProductAlerts,
		addProductAlert: _addProductAlert,
		addProductReview: _addProductReview,
		getProductReviews: _getProductReviews,
		getCustomerDetails: _getCustomerDetails,
		getExclusivityItems: _getExclusivityItems,
		getExclusivityItemsAem: _getExclusivityItemsAem,
		getStoreConfig: _getStoreConfig,
		checkIfEligible: _checkIfEligible,
		sendQuizStatus: _sendQuizStatus,
		getQuizQuestions: _getQuizQuestions,
		makePostRequest: _makePostRequest,
		makePostRequestRest: _makePostRequestRest,
		makeGetRequestRest: _makeGetRequestRest,
		makePostRequestWithAuthentication: _makePostRequestWithAuthentication,
		makeGetRequestWithAuthentication: _makeGetRequestWithAuthentication,
		updateCustomer: _updatecustomer,
		updateCustomerv2: _updatecustomerv2,
		submitLoginForm: _loginKr,
		submitKakaoLogin: _loginKrKakao,
		resendMailAccountConfirmation: _resendMailAccountConfirmation,
		isLoggedInUser: _isLoggedInUser,
		initCart: _initCart,
		verifyCart: _verifyCart,
		setCartDetails: _setCartDetails,
		checkPageRedirect: _checkPageRedirect,
		getCookieVal: _getCookieVal,
		setCookieVal: _setCookieVal,
		cartInterfaceKR: _cartInteraceKR,
		showToast: _showToast,
		fetchCart: _fetchCart,
		setLocalStorageItem: _setLocalStorageItem,
		isAuthorMode: _isAuthorMode,
		isUngatedPage: _isUngatedPage,
		toggleKakoLiveChat: _toggleKakoLiveChat,
		logoutUser: _logoutUser,
		isGuestUser: _isGuestUser,
		showLoginModal: _showLoginModal,
		hideLoginModal: _hideLoginModal,
		handleLoginPageRedirection: _handleLoginPageRedirection,
		checkDanalVerification: _checkDanalVerification,
		redirectNormalUser: _redirectNormalUser,
		handleAuthToken: _handleAuthToken,
		regenerateToken: _regenerateToken,
		phoneNumberFormat: _phoneNumberFormat,
		checkDOBFormat: _checkDOBFormat,
		mapProduct: _mapProduct,
		mapSelected: _mapSelected,
		openRcommendenProductModal: _openRcommendenProductModal
		// redirectToGatedPage: _redirectToGatedPage
	};
})
	();

// dispatch event which is firing the listener in analytics.js
//document.dispatchEvent(new CustomEvent('commerce.load'));